import React, {useEffect, useState} from "react";

import {Button, Col, Form, Layout as AntLayout, message, Modal, Row, Space} from 'antd';
import {
    AppButton,
    Container,
    ContainerStep,
    Logo,
    PageContent,
    PageFooter,
    PageHeader,
    ScheduleStep,
    StepsBody,
    Title
} from "./styles";
import Identification from "../../pages/Identification";
import Response from "../../models/Response";
import api from "../../service/api";

import {LoadingOutlined} from '@ant-design/icons';
import {NormalizeCpfOrCnpj} from "../../utils/StringUtils";
import AppParameters from "../../models/AppParameters";
import {AppSpin} from "../../global/styles";

import {Constants} from "../../utils/Constants";
import {environment} from "../../environments/environment";
import {decryptBase64Safe} from "../../utils/CryptoUtils";
import ScheduleDataCancellation from "../../models/ScheduleDataCancellation";
import VehicleTableData from "../../models/VehicleTableData";
import VehicleList from "../../pages/VehicleList";
import {Link as RouterLink} from "react-router-dom";

const LayoutCancellation: React.FC = (props) => {
    const {Step} = ScheduleStep;
    const [current, setCurrent] = useState<number>(0);

    const [form] = Form.useForm();
    const [loadStep, setLoadStep] = useState<boolean>(false);
    const [scheduleData, setScheduleData] = useState<VehicleTableData[]>([]);
    const [vehicleData, setVehicleData] = useState<VehicleTableData>({} as VehicleTableData);
    const [resetStep, setResetSep] = useState<boolean>(false);
    const [appParameters, setAppParameters] = useState<AppParameters>({} as AppParameters);
    const [enableNext, setEnableNext] = useState<boolean>(false);
    const [cameFromCancelling, setCameFromCancelling] = useState<boolean>(true);
    const [cpfCnpjParam, setCpfCnpjParam] = useState<any>();
    let [typeSchedule, setTypeSchedule] = useState<any>();

    useEffect(() => {
        if (window.location.href.includes('suhai')) {
            setAppParameters({
                company: 'Suhai',
                urlFavicon: 'favicon-suhai.png',
                urlLogo: 'logo-suhai.svg',
                primaryColor: '#DC3644',
                secondaryColor: '#DC3644',
                fontColor: '#fff',
                footerText: `Seu veículo bem-vindo, você seguro. ` + `${environment.version}`
            } as AppParameters);
        } else {
            let typeService = 'Cancelamento';
            typeSchedule = 1;

            setTypeSchedule(typeSchedule);
            setAppParameters({
                company: 'Tracker',
                urlFavicon: 'favicon-tracker.png',
                urlLogo: 'logo-tracker.png',
                primaryColor: '#e9e9e9',
                secondaryColor: '#DC3644',
                fontColor: 'rgba(0, 0, 0, 0.85)',
                footerText: `Grupo Tracker.` + ` ${environment.version}`,
                typeService: typeService
            } as AppParameters);
        }
    }, [])

    useEffect(() => {
        const favicon = document.getElementById("favicon") as HTMLLinkElement;
        favicon.href = appParameters.urlFavicon;
    }, [appParameters])

    useEffect(() => {
        if (resetStep) {
            form.resetFields();
            setCurrent(0);
        }
    }, [resetStep, form])

    useEffect(() => {
        // Verifica se está no primeiro passo (onde o usuário informa o CPF ou CNPJ)
        if (current === 0) {
            // Obtém os parâmetros da URL
            const urlParams = new URLSearchParams(window.location.search);
            // Verifica se existe um parâmetro chamado cpfCnpjParam na url
            if (urlParams.get('cpfCnpjParam')) {
                const encryptedCpfCnpjParam = urlParams.get('cpfCnpjParam');
                if (encryptedCpfCnpjParam) {
                    // const bytes = AES.decrypt(encryptedCpfCnpjParam, secretKey);
                    const decryptedData = decryptBase64Safe(encryptedCpfCnpjParam);
                    // Salvo o cpf/cnpj que veio como parãmetro em uma variável global
                    setCpfCnpjParam(decryptedData);
                }
                // Seto que veio do sistema de cancelamento de agendamentos.
                setCameFromCancelling(true);
                // Chama a função que avança para o próximo passo
                next();
            } else {
                setCameFromCancelling(false);
            }
        }
    }, [cpfCnpjParam, current]);

    useEffect(() => {
        if (current === 3) {
            setEnableNext(false);
        }
    }, [current]);

    const steps = [
        {
            title: 'Identificação',
            content: <Identification formRef={form} company={appParameters.company}
                                     typeService={appParameters.typeService}
                                     secondaryColor={appParameters.secondaryColor}/>,
        },
        {
            title: 'Veiculo',
            content: <VehicleList vehicles={scheduleData} />,
        }
    ];

    const next = () => {
        setLoadStep(true);
        //Step Identificação
        console.log(current)
        if (current === 0) {
            // Se veio da tela de cancelamento, executa direto a consulta com base no CPF que veio como parâmetro na URL.
            if (cpfCnpjParam) {
                setLoadStep(true);
                // Substituindo header por parâmetro de URL
                api.get<Response<ScheduleDataCancellation>>(
                    `scheduleExternal/searchVehiclesByCpfCnpj?cpfCnpj=${NormalizeCpfOrCnpj(cpfCnpjParam)}`,
                    { baseURL: environment.baseURLScot20})
                    .then(response => {
                        setScheduleData(response.data.object.object);

                        if (response.data.object.object == null || response.data.object.object.length === 0) {

                            Modal.warning({
                                title: 'Atenção!',
                                content: "Não foram encontrados veículos para realizar agendamento com o documento informado",
                                onOk: () => setResetSep(true),
                                okButtonProps: {
                                    style: {
                                        backgroundColor: appParameters.secondaryColor,
                                        borderColor: appParameters.secondaryColor
                                    }
                                }
                            });
                        } else {
                            /*
                             * @davidsantos
                             * Ajuste para garantir que o retorno de vehicleResponseDtoList seja sempre um array,
                             * mesmo quando o servidor retorna um único objeto ao invés de um array.
                             */
                            if (!Array.isArray(response.data.object.object)) {
                                let vehicleDtoList = [] as VehicleTableData[];
                                vehicleDtoList.push(response.data.object.object);
                                response.data.object.object = vehicleDtoList;
                            }

                        }
                        setLoadStep(false);
                    })
                    .catch(error => {
                        setLoadStep(false);
                        console.error("Erro na requisição:", error);
                    });
            } else if (!cameFromCancelling) {
                // Se não veio da tela de cancelamento, segue o passo a passo manual, onde o usuário precisa informar manualmente seu CPF/CNPJ e prosseguir.
                form.validateFields()
                    .then(async identification => {

                        const cpfCnpj = NormalizeCpfOrCnpj(identification.cpfCnpj);

                        const response = await api.get<Response<ScheduleDataCancellation>>(
                            `scheduleExternal/searchVehiclesByCpfCnpj?cpfCnpj=${NormalizeCpfOrCnpj(cpfCnpj)}`,
                            { baseURL: environment.baseURLScot20 }
                        );

                        setScheduleData(response.data.object.object);

                        if (response.data.object.object == null || response.data.object.object.length === 0) {
                            Modal.warning(
                                {
                                    title: 'Atenção!',
                                    content: "Não foram encontrados veículos para realizar agendamento com o documento informado",
                                    onOk: () => setResetSep(true),
                                    okButtonProps: {
                                        style: {
                                            backgroundColor: appParameters.secondaryColor,
                                            borderColor: appParameters.secondaryColor
                                        }
                                    }
                                }
                            )
                        } else {

                            if (!response.data?.object?.object) {
                                console.error("Erro: response.data.object.object está undefined");
                                return;
                            }

                            if (!Array.isArray(response.data.object.object)) {
                                let vehicleDtoList = [] as VehicleTableData[];
                                vehicleDtoList.push(response.data.object.object);
                                response.data.object.object = vehicleDtoList;
                            }

                            // Apenas avança um passo e define os dados do veículo (se houver)
                            if (response.data.object.object.length > 0) {
                                setVehicleData(response.data.object.object[0]);
                            }

                            setCurrent(current + 1);
                        }

                        setLoadStep(false);
                    })
                    .catch(async error => {
                        if (error.response) {
                            if (error.response.status === 400) {
                                if (window.location.href.includes(Constants.LINK_SUHAI)) {
                                    form.setFields([{name: 'cpfCnpj', errors: [Constants.MSG_ERRO_SUHAI]}])
                                } else {
                                    form.setFields([{name: 'cpfCnpj', errors: error.response.data.errors}])
                                }
                            } else if (error.response.status === 404) {
                                form.setFields([{
                                    name: 'cpfCnpj',
                                    errors: ['CPF/CNPJ não encontrado na base de dados.']
                                }])
                            } else {
                                form.setFields([{name: 'cpfCnpj', errors: ['Ocorreu um erro, tente novamente!']}])
                            }
                        } else {
                            form.setFields([{
                                name: 'cpfCnpj',
                                errors: ['Não foram encontrados veículos para realizar agendamento com o documento informado']
                            }])
                        }

                        setLoadStep(false);
                    })
            }
        }
    };

    const prev = () => {
        if (current === 2 && (scheduleData == null || scheduleData.length <= 1)) {
            setCurrent(current - 2);
        } else {
            setCurrent(current - 1);
        }
    };

    return (
        <AntLayout>
            <PageHeader headercolor={appParameters.primaryColor}>
                <Logo src={appParameters.urlLogo}/>
            </PageHeader>
            <PageContent>
                <Title bordercolor={appParameters.secondaryColor}>Central de Cancelamento de Agendamento Online</Title>
                <Container>
                    <ContainerStep>
                        <Space direction="vertical" size="middle" style={{display: 'flex'}}>
                            <ScheduleStep stepcolor={appParameters.secondaryColor} current={current}>
                                {steps.map((item, key) => (
                                    <Step key={item.title} title={item.title} icon={current === key && loadStep &&
                                        <LoadingOutlined color={appParameters.secondaryColor}/>}/>
                                ))}
                            </ScheduleStep>
                            <AppSpin color={appParameters.secondaryColor} spinning={loadStep}>
                                <StepsBody className="steps-content">
                                    {steps[current].content}
                                </StepsBody>


                                <Row gutter={16} justify="center" style={{paddingTop: '10px'}}>
                                    <Col span={24}>
                                        <div className="steps-action">
                                            {current > 0 && (
                                                <AppButton type="default" color={appParameters.secondaryColor}
                                                           style={{margin: '0 8px'}} onClick={() => prev()}>
                                                    Anterior
                                                </AppButton>
                                            )}
                                            {current < steps.length - 1 && (
                                                <AppButton type="default" color={appParameters.secondaryColor}
                                                           onClick={next} disabled={current === 3 && !enableNext}>
                                                    Proximo
                                                </AppButton>
                                            )}
                                        </div>
                                        <div
                                            style={{
                                                margin: "auto",
                                                display: "table",
                                            }}
                                        >
                                            <h4>
                                                Caso queira realizar o agendamento,{" "}
                                                <RouterLink to="/">clique aqui.</RouterLink>
                                            </h4>

                                        </div>

                                    </Col>
                                </Row>
                            </AppSpin>
                        </Space>
                    </ContainerStep>

                </Container>
            </PageContent>
            <PageFooter footercolor={appParameters.primaryColor}
                        fontcolor={appParameters.fontColor}>{appParameters.footerText}</PageFooter>
        </AntLayout>
    );

}

export default LayoutCancellation;
